// src/components/InfoCards/InfoCards.js
import React from 'react';
import './InfoCards.css';

const InfoCards = ({ cards }) => (
  <div className="building">
    <h3>What We’re Building</h3>
    <div className="cards-container">
      {cards.map((c, i) => (
        <div key={i} className="card">
          <div className="card-icon">
            <img src={c.icon} alt={c.title} />
          </div>
          <h4>{c.title}</h4>
          <p>{c.description}</p>
        </div>
      ))}
    </div>
  </div>
);

export default InfoCards;
